function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#0078D7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9992 9.00398C14.9992 9.05077 14.9992 9.09444 14.996 9.14123C14.6346 9.06325 14.2576 9.00086 13.8682 8.95095C13.8401 7.94339 13.0176 7.13546 12.005 7.13546C10.9924 7.13546 10.1668 7.94339 10.1419 8.95095C9.75243 9.00086 9.37543 9.06325 9.01402 9.14123C9.0109 9.09444 9.0109 9.04765 9.0109 9.00086C9.0109 7.34446 10.3506 6 12.0081 6C13.6563 6.00624 14.9992 7.34758 14.9992 9.00398ZM12.0175 18.0003C17.3078 15.7731 16.5009 10.102 16.5009 10.102C15.2671 9.64034 13.7093 9.36583 12.0113 9.36583C10.3132 9.36583 8.75542 9.64034 7.52163 10.102C7.52163 10.102 6.71468 15.7731 12.005 18.0003H12.0175Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4758 14.4284C13.4758 14.4939 13.4726 14.5563 13.4633 14.6187H10.5564C10.5471 14.5563 10.5439 14.4939 10.5439 14.4284C10.5439 13.7671 10.9801 13.2087 11.5815 13.0247C11.1764 12.8562 10.8898 12.4569 10.8898 11.989C10.8898 11.3683 11.3914 10.8691 12.0083 10.8691C12.6252 10.8691 13.1268 11.3714 13.1268 11.989C13.1268 12.4569 12.8402 12.8562 12.4351 13.0247C13.0396 13.2056 13.4758 13.7671 13.4758 14.4284Z",
  fill: "#0078D7"
});

var SvgIconMsa = function SvgIconMsa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMsa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconMSA.f5601a5f.svg";
export { ForwardRef as ReactComponent };